export default function Footer() {
  return (
    <footer className="bg-[#f6f2ea] text-[#3a2f23]">

      {/* MAIN FOOTER */}
      <div className="max-w-7xl mx-auto px-6 py-20 grid grid-cols-1 md:grid-cols-5 gap-12">

        {/* BRAND */}
        <div className="md:col-span-1">
          <h2 className="font-serif text-2xl tracking-widest mb-4">
            <a href="/" className="hover:text-[#0a7d4f] transition">KAALI</a>
          </h2>
          <p className="text-sm leading-relaxed text-[#6b5a45]">
            Kaali Global Import & Export supplies premium Cardamom and
            Black Pepper sourced directly from Indian farms, serving
            domestic and global markets.
          </p>
        </div>

        {/* Learn */}
        <div>
          <h4 className="font-serif font-semibold mb-4">
            Learn
          </h4>
          <ul className="space-y-3 text-sm text-[#6b5a45]">
            <li className="hover:text-black cursor-pointer">About Us</li>
            <li className="hover:text-black cursor-pointer">Our Sourcing</li>
            <li className="hover:text-black cursor-pointer">Quality Standards</li>
          </ul>
        </div>

        {/* Products */}


        {/* Business */}
        <div>
          <h4 className="font-serif font-semibold mb-4">
            Contact
          </h4>
          <ul className="space-y-3 text-sm text-[#6b5a45]">
            <li>
              <a href="mailto:info@kaaliglobal.com?subject=Business%20Inquiry" className="hover:text-black transition">
                info@kaaliglobal.com
              </a>
            </li>
            <li><a href="tel:+919944940620" className="hover:text-black transition">+91 99449 40620</a></li>
            <li>Tamil Nadu, India</li>
          </ul>
        </div>


        {/* NEWSLETTER */}


      </div>

      {/* DISCLAIMER */}
      <div className="max-w-5xl mx-auto px-6 text-xs text-center text-[#6b5a45] leading-relaxed pb-10">
        <p>
          Kaali Global Import & Export supplies premium agricultural products,
          including Cardamom and Black Pepper, for export and domestic markets.
          Product specifications and availability may vary based on sourcing
          and harvest conditions.
        </p>

        <p className="mt-4 underline cursor-pointer">
          Privacy Policy | Terms & Conditions
        </p>
      </div>

      {/* SOCIAL MEDIA */}
      <div className="bg-white py-10 text-center">
        <p className="text-sm mb-6 text-[#6b5a45]">
          Connect with us
        </p>

        <div className="flex justify-center gap-8">
          {/* Instagram */}
          <a href="https://www.instagram.com/kaali_global/" target="_blank" className="text-[#c9a24d] hover:text-black transition">
            <svg width="22" height="22" fill="currentColor" viewBox="0 0 24 24">
              <path d="M7 2C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5H7zm10 2a3 3 0 013 3v10a3 3 0 01-3 3H7a3 3 0 01-3-3V7a3 3 0 013-3h10zm-5 3a5 5 0 100 10 5 5 0 000-10zm0 2a3 3 0 110 6 3 3 0 010-6zm4.5-.9a1.1 1.1 0 100 2.2 1.1 1.1 0 000-2.2z" />
            </svg>
          </a>

          {/* Facebook */}


          {/* LinkedIn */}


          {/* Email */}
          <a
            href="mailto:info@kaaliglobal.com?subject=Business%20Inquiry"
            target="_blank"
            title="info@kaaliglobal.com"
            className="text-[#c9a24d] hover:text-black transition"
          >
            <svg width="22" height="22" fill="currentColor" viewBox="0 0 24 24">
              <path d="M2 4h20v16H2V4zm10 7L4 6v12h16V6l-8 5z" />
            </svg>
          </a>
        </div>
      </div>

      {/* COPYRIGHT */}
      <div className="bg-[#efe7db] py-5 text-center text-xs text-[#6b5a45]">
        © {new Date().getFullYear()} Kaali Global Import & Export. All rights reserved.
      </div>

    </footer>
  );
}
